module.exports = __webpack_public_path__ + "img/peuter_zach-katoen.90483726.webp";